<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <ThankYou></ThankYou>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import ThankYou from '@/components/blocks/ThankYou.vue'
import http from "@/api/http";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        ThankYou
    },
    data() {
        return {
            classes: []
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init() {
            let { data } = await http.get('statement-of-use-extension/step-thank-you/' + this.$route.params.key);

            if (data.res) {
                this.classes = data.data.data.classes

                if (data.data.data.status != 'C' || data.data.data.status_payment != 'Y') {
                    this.$router.push({ path: '/statement-of-use-extension/step-2/' + this.$route.params.key })
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
    },
    computed: {
        countElements() {
            return 6 + this.classes.length
        }
    }
}
</script>
